import axios from 'axios';

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    if (typeof response.headers['lw-token-refreshed'] !== 'undefined') {
        window.usertoken = response.headers['lw-token-refreshed'];
    }
    // Do something with response data
    // console.log(response);
    return response;
}, function (error) {
    // Do something with response error
    return Promise.reject(error);
});

// Add a request interceptor
axios.interceptors.request.use(function(config) {
    let token = window.usertoken? window.usertoken : '';

    const hasRequestUrlWithBase = config.url.indexOf('//') > -1;

    if ( token != '' && hasRequestUrlWithBase? config.url.indexOf(window.server) > -1 : config.baseURL.indexOf(window.server) > -1) {
        config.headers.Token = `${token}`;
    }

    return config;
}, function(err) {
    return Promise.reject(err);
});

export default axios;